import {
    collection,
    addDoc,
    getDocs,
    deleteDoc,
    doc,
    query,
    orderBy,
    where
} from 'firebase/firestore';
import { db } from '../../../config/firebase';

export const paymentService = {
    // Lấy tất cả thanh toán của user
    async getPayments(userId) {
        try {
            const q = query(
                collection(db, `users/${userId}/payments`),
                orderBy('ngayTra', 'desc')
            );
            const querySnapshot = await getDocs(q);
            return querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data(),
                ngayTra: doc.data().ngayTra?.toDate(),
                createdAt: doc.data().createdAt?.toDate()
            }));
        } catch (error) {
            console.error('Error fetching payments:', error);
            throw error;
        }
    },

    // Thêm thanh toán mới
    async addPayment(userId, paymentData) {
        try {
            const docRef = await addDoc(collection(db, `users/${userId}/payments`), {
                ...paymentData,
                createdAt: new Date()
            });
            return docRef.id;
        } catch (error) {
            console.error('Error adding payment:', error);
            throw error;
        }
    },

    // Lấy thanh toán theo debt ID
    async getPaymentsByDebtId(userId, debtId) {
        try {
            const q = query(
                collection(db, `users/${userId}/payments`),
                where('debtId', '==', debtId),
                orderBy('ngayTra', 'desc')
            );
            const querySnapshot = await getDocs(q);
            return querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data(),
                ngayTra: doc.data().ngayTra?.toDate(),
                createdAt: doc.data().createdAt?.toDate()
            }));
        } catch (error) {
            console.error('Error fetching payments by debt ID:', error);
            throw error;
        }
    },

    // Xóa thanh toán
    async deletePayment(userId, paymentId) {
        try {
            await deleteDoc(doc(db, `users/${userId}/payments`, paymentId));
        } catch (error) {
            console.error('Error deleting payment:', error);
            throw error;
        }
    },

    // Xóa tất cả thanh toán của một nợ
    async deletePaymentsByDebtId(userId, debtId) {
        try {
            const payments = await this.getPaymentsByDebtId(userId, debtId);
            const deletePromises = payments.map(payment =>
                this.deletePayment(userId, payment.id)
            );
            await Promise.all(deletePromises);
        } catch (error) {
            console.error('Error deleting payments by debt ID:', error);
            throw error;
        }
    },
};
